<template>
    <div class="row py-3 bt-dash">
        <h6 class="f-w-700 mb-3">Departments</h6>
        <div class="custom-scrollbar list-container px-3 nav-link" style=" height: 290px;">
            <div class=" text-center text-white rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center gap-2"
                @click="onDepartmentClick(item.id)"
                :style="{ backgroundColor: findColorById(item.appearance.buttonColor), boxShadow: findOnSelectedDepartment(item.id) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }"
                style="grid-column: span 1 / span 1; height: 112px;" v-for="item in navigationLinksMock.departments">
                <img v-if="item?.appearance?.image" :src="item.appearance.image" alt="department image"
                    class="object-fit-cover w-25 ratio1-1 border-0" />
                <h5 class=" text-white" :style="{ fontSize: calcFontSize(item.appearance.fontSizes) }">
                    {{ item.name }}</h5>
            </div>
        </div>
        <h6 class="f-w-700 my-3">Product Groups</h6>
        <div class="custom-scrollbar list-container px-3 nav-link" style=" height: 290px;">
            <div class=" text-center text-white rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center gap-2"
                @click="onProductGroupClick(item.id)"
                :style="{ backgroundColor: findColorById(item.appearance.buttonColor), boxShadow: findOnSelectedProductGroup(item.id) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }"
                style="grid-column: span 1 / span 1; height: 112px;" v-for="item in navigationLinksMock.productGroups">
                <img v-if="item?.appearance?.image" :src="item.appearance.image" alt="department image"
                    class="object-fit-cover w-25 ratio1-1 border-0" />
                <h5 class=" text-white" :style="{ fontSize: calcFontSize(item.appearance.fontSizes) }">
                    {{ item.name }}</h5>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, computed, watch } from 'vue'
import { NavigationLinks, NavigationLinksItem, ProductGroup } from '@/store/management/productGroupsStore'
import { useProductGroupsStore } from '@/store/management/productGroupsStore'

const productGroupsStore = useProductGroupsStore()

const compState = reactive({
    selectedDepartment: [] as NavigationLinksItem[],
    selectedProductGroup: [] as NavigationLinksItem[],
})

const navigationLinksMock: NavigationLinks = {
    departments: [
        { id: '1', name: 'Kitchen', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '2', name: 'Bar', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '3', name: 'Service', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '4', name: 'Management', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '5', name: 'Delivery', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '6', name: 'Takeout', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '7', name: 'Catering', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '8', name: 'Events', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '9', name: 'Marketing', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '10', name: 'Finance', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '11', name: 'Human Resources', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '12', name: 'Maintenance', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '13', name: 'Security', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '14', name: 'Customer Service', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '15', name: 'Reservations', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
    ],
    productGroups: [
        { id: '1', name: 'Appetizers', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '2', name: 'Salads', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '3', name: 'Soups', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '4', name: 'Main Courses', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '5', name: 'Sides', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '6', name: 'Desserts', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '7', name: 'Beverages', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '8', name: 'Cocktails', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '9', name: 'Wine', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '10', name: 'Beer', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '11', name: 'Breakfast', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '12', name: 'Lunch', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '13', name: 'Dinner', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '14', name: 'Specials', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
        { id: '15', name: 'Kids Menu', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium' } },
    ],
};

const colorList = ref([
    { id: '1', name: 'Red', color: '#FF0000' },
    { id: '2', name: 'Green', color: '#00aa00' },
    { id: '3', name: 'Blue', color: '#0000FF' },
    { id: '4', name: 'Yellow', color: '#FFFF00' },
    { id: '5', name: 'Cyan', color: '#00FFFF' },
    { id: '6', name: 'Magenta', color: '#FF00FF' },
    { id: '7', name: 'Orange', color: '#FFA500' },
    { id: '8', name: 'Purple', color: '#800080' },
    { id: '9', name: 'Brown', color: '#A52A2A' },
    { id: '10', name: 'Pink', color: '#FFC0CB' },
    { id: '11', name: 'Lime', color: '#32cd32' },
    { id: '12', name: 'Teal', color: '#008080' },
]);


const activeProductGroup = computed(() => {
    return productGroupsStore.getActiveProductGroup
})

const tempActiveProductGroup = computed(() => {
    return productGroupsStore.getTempActiveProductGroup
})

const activeProductGroupId = computed(() => {
    return productGroupsStore.getActiveProductGroupId
})

onMounted(() => {
    if (tempActiveProductGroup.value?.id) {
        compState.selectedDepartment = tempActiveProductGroup.value?.navigationLinks?.departments || [] as NavigationLinksItem[]
        compState.selectedProductGroup = tempActiveProductGroup.value?.navigationLinks?.productGroups || [] as NavigationLinksItem[]
    }
})

watch(activeProductGroupId, (newVal) => {
    if (tempActiveProductGroup.value?.id) {
        compState.selectedDepartment = tempActiveProductGroup.value?.navigationLinks?.departments || [] as NavigationLinksItem[]
        compState.selectedProductGroup = tempActiveProductGroup.value?.navigationLinks?.productGroups || [] as NavigationLinksItem[]
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productGroupsStore.setTempActiveProductGroup({
        ...tempActiveProductGroup.value,
        navigationLinks: {
            departments: newVal.selectedDepartment,
            productGroups: newVal.selectedProductGroup
        },
    })
}, { deep: true });

const findOnSelectedDepartment = (id: string) => {
    return compState.selectedDepartment.find((department) => department.id === id)
}
const findOnSelectedProductGroup = (id: string) => {
    return compState.selectedProductGroup.find((productGroup) => productGroup.id === id)
}

const findColorById = (id: string) => {
    return colorList.value.find((color) => color.id === id)?.color || '#dddddd'
}

const calcFontSize = (fontSize: string) => {
    return fontSize === 'X-Large' ? '1.5rem' : fontSize === 'Large' ? '1.25rem' : fontSize === 'Medium' ? '1rem' : '0.875rem'
}
const onDepartmentClick = (id: string) => {
    const department = navigationLinksMock.departments.find((department) => department.id === id)
    if (findOnSelectedDepartment(id)) {
        compState.selectedDepartment = compState.selectedDepartment.filter((department) => department.id !== id)
    } else {
        if (department) {
            compState.selectedDepartment.push(department)
        }

    }
}
const onProductGroupClick = (id: string) => {
    const productGroup = navigationLinksMock.productGroups.find((productGroup) => productGroup.id === id)
    if (findOnSelectedProductGroup(id)) {
        compState.selectedProductGroup = compState.selectedProductGroup.filter((productGroup) => productGroup.id !== id)
    } else {
        if (productGroup) {
            compState.selectedProductGroup.push(productGroup)
        }

    }
}
</script>

<style lang="scss" scope>
.list-container {
    display: grid !important;
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    gap: 1rem;
}
</style>